"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const bignumber_js_1 = require("bignumber.js");
class Rebase {
    constructor(data) {
        this.data = data;
    }
    get epoch() {
        return new bignumber_js_1.BigNumber(this.data.epoch);
    }
    get timestamp() {
        return new bignumber_js_1.BigNumber(this.data.timestamp);
    }
    get supply() {
        return new bignumber_js_1.BigNumber(this.data.supply);
    }
    get previousSupply() {
        return new bignumber_js_1.BigNumber(this.data.previousSupply);
    }
    get supplyAdjustment() {
        return new bignumber_js_1.BigNumber(this.data.supplyAdjustment);
    }
    get rebasePerc() {
        return new bignumber_js_1.BigNumber(this.data.precentageChange);
    }
    get price() {
        return new bignumber_js_1.BigNumber(this.data.marketRate);
    }
    get priceTarget() {
        return new bignumber_js_1.BigNumber(this.data.targetRate);
    }
    get targetRate() {
        return new bignumber_js_1.BigNumber(this.data.targetRate);
    }
    get marketCap() {
        return this.price.multipliedBy(this.supply);
    }
    get rawData() {
        return this.data;
    }
}
exports.default = Rebase;
//# sourceMappingURL=Rebase.js.map